import { Box } from "@mui/material"
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import HomePageSegmentsHandler from "./HomePageSegmentHandler";

const HomeContentSection = () => {

    return (
        <DndProvider backend={HTML5Backend} >
            <Box sx={{ py: 1, px: '20px', flexGrow: 1, overflow: 'auto' }}>
                <HomePageSegmentsHandler />
            </Box>
        </DndProvider>
    )
}

export default HomeContentSection